import { isSameDay, type Locale } from 'date-fns';
import { formatDate } from 'src/common/utils/dateHelpers';

const DISPLAY_DATE_FORMAT = 'MMM dd';

const getTitle = (
  t: (key: string) => string,
  dates: { start: Date; end: Date },
  locale: Locale,
): string => {
  const { start, end } = dates;
  if (start && end && !isSameDay(start, end)) {
    const formattedStartDate = formatDate(start, DISPLAY_DATE_FORMAT, locale);
    const formattedEndDate = formatDate(end, DISPLAY_DATE_FORMAT, locale);
    return `${formattedStartDate} - ${formattedEndDate}`;
  }
  if (start) {
    const formattedStartDate = formatDate(start, DISPLAY_DATE_FORMAT, locale);
    return formattedStartDate;
  }
  return t('snooze-listing--calendar-title');
};

export default getTitle;
